import React, { Component, useState } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import classnames from 'classnames';
import * as router from 'react-router-dom';
import {
     Container,
     Badge,
     DropdownToggle,
     DropdownMenu,
     TabContent,
     TabPane,
     Nav,
     NavItem,
     NavLink,
     Card,
     Button,
     CardTitle,
     CardText,
     Row,
     Col
} from 'reactstrap';
import routes from '../../routes.js';
import 'react-notifications/lib/notifications.css';
import {LoginContext} from '../../components/ParadigmaLoginProvider/ParadigmaLoginProvider.js';
import LoginProvider from '../../components/ParadigmaLoginProvider/ParadigmaLoginProvider.js';
import CartProvider from '../../components/ParadigmaCartProvider/ParadigmaCartProvider.js';
import Carrito from '../../components/Carrito/Carrito.js';
import {NotificationContainer} from 'react-notifications';
import DefaultHeader from './DefaultHeader.js';
import logoParadigmaHorizontal from '../../assets/img/paradigma-horizontal.jpg';
import moment from 'moment';

const DefaultLayout = (props) => {
     const [showCarritoModal, setShowCarritoModal] = useState(false);
     const [CarruselLength, setCarruselLength] = useState(0);
     return (
          <LoginProvider>
               <CartProvider>
                    <div className="app">
                         {
                              <LoginContext.Consumer>
                                   {
                                        ({logged, logout}) => {
                                             return logged == true ? <DefaultHeader showLogo={CarruselLength == 0} setCarruselLength={(value)=>setCarruselLength(value)} showCarritoModal={()=>setShowCarritoModal(true)} logout={()=>logout != undefined && logout != null && logout()}/> : null
                                        }
                                   }
                              </LoginContext.Consumer>
                         }
                         <Switch>
                              {
                                   routes.filter(x => x.logged == false).map(
                                        (route, idx) => (route.component != undefined && route.component != null ? <Route key={idx} path={route.path} exact={route.exact} name={route.name} render={(props) => (<route.component {...props} />)} /> : null)
                                   )
                              }
                              <LoginContext.Consumer>
                                   {
                                        ({ logged }) => {
                                             if (logged == true) {
                                                  return routes.filter(x => x.logged == true).map(
                                                       (route, idx) => route.component != undefined && route.component != null ? <Route key={idx} path={route.path} exact={route.exact} name={route.name} render={(props) => (<route.component {...props} setCarruselLength={(value)=>setCarruselLength(value)} />) } /> : null
                                                  );
                                             } else {
                                                  return routes.filter(x => x.logged == true).map((route, idx) => (<Redirect key={idx} path={route.path} to={"/"} exact={route.exact} />));
                                             }
                                        }
                                   }
                              </LoginContext.Consumer>
                         </Switch>
                         {
                              <LoginContext.Consumer>
                                   {
                                        ({logged, logout}) => {
                                             return logged == true ?
                                                  <footer>
                                                       <p className="text-center pt-2">
                                                            Desarrollado por
                                                            <a href="http://www.paradigma.com.ar">
                                                                 <img
                                                                      src={logoParadigmaHorizontal}
                                                                      alt="Logo Paradigma del Sur S.A."
                                                                      className="mr-2"
                                                                 />
                                                            </a>
                                                            ®
                                                            <small className="d-inline"> { moment().format('YYYY') } </small>
                                                       </p>
                                                  </footer>
                                             :
                                             null
                                        }
                                   }
                              </LoginContext.Consumer>
                         }
                         <NotificationContainer/>
                         <Carrito show={showCarritoModal} hide={()=>setShowCarritoModal(false)}/>
                    </div>
               </CartProvider>
          </LoginProvider>
     );
}

export default DefaultLayout;



// WEBPACK FOOTER //
// ./src/containers/DefaultLayout/DefaultLayout.js